import type {
  IBannerUpsertByCustomerListValues,
  IBannerUpsertBySegmentValues,
  IBannerUpsertValues,
  TUpsertBannerParams,
} from 'core/model/interfaces/banners';

export const BANNERS_FILTERS_FORM_ATTRIBUTES = {
  form: {
    id: 'banners-filters-form',
    name: 'banners-filters-form',
  },
  zone: {
    id: 'zoneIdList',
    name: 'zoneIdList',
  },
  /**
   * Branch (Sucursal/Sede)
   */
  distributor: {
    id: 'distributorIdList',
    name: 'distributorIdList',
  },
  priceGroup: {
    id: 'priceGroupIdList',
    name: 'priceGroupIdList',
  },
  priceList: {
    id: 'priceListIdList',
    name: 'priceListIdList',
  },
} as const;

/**
 * Complete the rest properties of the type
 */
export const BANNERS_CREATION_FORM_ATTRIBUTES: TFormField<Omit<IBannerUpsertValues, 'platform' | 'bannerCode'>> = {
  form: {
    id: 'bannersCreationForm',
    name: 'bannersCreationForm',
  },
  bannerName: {
    id: 'bannerName',
    name: 'bannerName',
  },
  mobileImageFile: {
    id: 'mobileImageFile',
    name: 'mobileImageFile',
  },
  desktopImageFile: {
    id: 'desktopImageFile',
    name: 'desktopImageFile',
  },
  bannerType: {
    id: 'bannerType',
    name: 'bannerType',
  },
  bannerTarget: {
    id: 'bannerTarget',
    name: 'bannerTarget',
  },
  bannerLinkImageUrl: {
    id: 'bannerLinkImageUrl',
    name: 'bannerLinkImageUrl',
  },
  popupImageFile: {
    id: 'popupImageFile',
    name: 'popupImageFile',
  },
  promotionList: {
    id: 'promotionList',
    name: 'promotionList',
  },
  zoneIdList: BANNERS_FILTERS_FORM_ATTRIBUTES.zone,
  distributorIdList: BANNERS_FILTERS_FORM_ATTRIBUTES.distributor,
  priceGroupIdList: BANNERS_FILTERS_FORM_ATTRIBUTES.priceGroup,
  priceListIdList: BANNERS_FILTERS_FORM_ATTRIBUTES.priceList,
  customerCodes: {
    id: 'customerCodes',
    name: 'customerCodes',
  },
  excludedCustomerCodes: {
    id: 'excludedCustomerCodes',
    name: 'excludedCustomerCodes',
  },
  shouldExcludeCustomers: {
    id: 'shouldExcludeCustomers',
    name: 'shouldExcludeCustomers',
  },
  bannerStartDate: {
    id: 'bannerStartDate',
    name: 'bannerStartDate',
  },
  bannerStartTime: {
    id: 'bannerStartTime',
    name: 'bannerStartTime',
  },
  bannerEndDate: {
    id: 'bannerEndDate',
    name: 'bannerEndDate',
  },
  bannerEndTime: {
    id: 'bannerEndTime',
    name: 'bannerEndTime',
  },
};

/**
 * Specific error codes for banner form validation.
 */
export const BANNER_SPECIFIC_ERROR_CODE_LIST = ['SFE1906', 'SFE1909'] as const;

export const BANNER_MAP_SPECIFIC_ERROR_CODE_LIST = new Map<
  (typeof BANNER_SPECIFIC_ERROR_CODE_LIST)[number],
  keyof TUpsertBannerParams
>([
  ['SFE1906', 'customerCodes'],
  ['SFE1909', 'excludedCustomerCodes'],
]);

export const BANNERS_KEYNAME_ERROR_LIST: Array<
  keyof IBannerUpsertByCustomerListValues | keyof Pick<IBannerUpsertBySegmentValues, 'excludedCustomerCodes'>
> = ['customerCodes', 'excludedCustomerCodes'];

export const BANNERS_FORM_FIELD_RULES = {
  CUSTOMER_CODES: 5000,
  EXCLUDED_CUSTOMER_CODES: 5000,
} as const;
